export const PASSWORD_MIN_LENGTH = 8

export const STRIPE_PRODUCTS = {
  JOB_POSTING: "job_posting",
  SEND_JOB_POST_TO_MATCH: "send_job_post_match",
  UNLOCK_APPLICANT_RESUME: "unlock_applicant_resume",
  SKILLED_WORKER_PRIORITY_ACCESS: "skilled_worker_priority_access",
  UNLOCK_APPLICANT_RESUME_SKILL_2: "unlock_applicant_resume_skill_2",
  UNLOCK_APPLICANT_RESUME_SKILL_3: "unlock_applicant_resume_skill_3",
}

export const MINOR_WORDS = [
  "a",
  "an",
  "and",
  "the",
  "but",
  "or",
  "for",
  "nor",
  "as",
  "at",
  "by",
  "for",
  "from",
  "in",
  "into",
  "near",
  "of",
  "on",
  "onto",
  "to",
  "with",
]

export const API_RESPONSE_ERRORS = {
  INVALID_ZIP_CODE_ERROR: "Could not process the location coordinates",
}
export const ERROR_MESSAGES = {
  INVALID_ZIP_CODE_INPUT: "Please enter a valid zip code",
}

// sessionStorage key for the company info collected on /hire before signup
// (GFB-1413): { companyName, zip, trades }.
export const COMPANY_ONBOARDING_KEY = "gfb_company_onboarding"

// "Popular" one-click trade suggestions shown under the jobseeker trade
// picker on /find-work and /complete-profile (GFB-1421). Must be exact
// GET /api/categories names.
export const POPULAR_JOBSEEKER_TRADES = [
  "General Labor",
  "Carpentry",
  "Plumbing & Pipefitting",
  "Heating & A/C",
  "Electrical",
]

// "Popular" one-click suggestions under "Trades your company performs" on
// /hire (GFB-1422). Must be exact GET /api/categories names, or "General
// Contractor" (which /hire adds to the picker's options).
export const POPULAR_COMPANY_TRADES = [
  "General Contractor",
  "Carpentry",
  "Plumbing & Pipefitting",
  "Heating & A/C",
  "Electrical",
]
